import { apiService } from './api';
import { BackupItem, BackupStats, BackupListParams, ApiResponse } from '../types';

export const backupApi = {
  // Create a new backup
  create: (): Promise<ApiResponse<BackupItem>> => 
    apiService.post('/backups'),

  // List backups with filtering and pagination
  list: (params?: BackupListParams): Promise<ApiResponse<BackupItem[]>> => 
    apiService.get('/backups', { params }),

  // Get backup details
  getById: (backupId: string): Promise<ApiResponse<BackupItem>> => 
    apiService.get(`/backups/${backupId}`),

  // Download backup file
  download: (backupId: string): Promise<Blob> => 
    apiService.get(`/backups/${backupId}/download`, { 
      responseType: 'blob' 
    }),

  // Delete backup
  delete: (backupId: string): Promise<ApiResponse<void>> => 
    apiService.delete(`/backups/${backupId}`),

  // Get backup statistics
  getStats: (): Promise<ApiResponse<BackupStats>> => 
    apiService.get('/backups/stats/overview'),

  // Cleanup old backups
  cleanup: (): Promise<ApiResponse<{ deletedCount: number }>> => 
    apiService.post('/backups/cleanup'),

  // Fix stuck backups
  fixStuck: (): Promise<ApiResponse<{ fixedCount: number }>> => 
    apiService.post('/backups/fix-stuck')
};
